<div class="col-12">
  <p-checkbox name="hasWebsite" (click)="formDirty = true" [(ngModel)]="filter.hasWebsite" [disabled]="readOnly" binary="true"></p-checkbox>
  <label>Website</label>
</div>
<div class="col-12">
  <p-checkbox name="noWebsite" (click)="formDirty = true" [(ngModel)]="filter.noWebsite" [disabled]="readOnly" binary="true"></p-checkbox>
  <label>No Website</label>
</div>

<!-- p-tree does not have implementation of value control accessor the hack below implements this -->
<fieldset ngModelGroup="”hasWebsiteModGrp”">
  <input type="hidden" [(ngModel)]="filter.hasWebsite" name="hasWebsiteField" #hasWebsiteField="ngModel" required />
  <input type="hidden" [(ngModel)]="filter.noWebsite" name="noWebsiteField" #noWebsiteField="ngModel" required />
  <div class="row">
    <div class="col=12">
      <span class="help-block">
        <span *ngIf="formDirty && ((hasWebsiteField.invalid && noWebsiteField.invalid) || (!filter.hasWebsite && !filter.noWebsite))">
          Please select an option
        </span>
      </span>
    </div>
  </div>
</fieldset>
